import React from 'react';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';

const DisplayDate = ({ dateText }) => (
  <div data-testid="display-date" className="display-date">
    {DateTime.fromISO(dateText, {
      zone: 'utc',
    })
      .toLocal()
      .toFormat('d LLL yyyy')}
  </div>
);

DisplayDate.propTypes = {
  dateText: PropTypes.string.isRequired,
};

export default DisplayDate;
